/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Claimd_ContentInputs */

const en_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reward has already been claimed.`)
};

const ar_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم بالفعل المطالبة بالمكافأة.`)
};

const de_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Belohnung wurde bereits in Anspruch genommen.`)
};

const es_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La recompensa ya ha sido reclamada.`)
};

const fr_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La récompense a déjà été réclamée.`)
};

const it_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ricompensa è già stata riscattata.`)
};

const ja_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この報酬はすでに受け取り済みです。`)
};

const ko_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드를 이미 받았어요.`)
};

const pt_br_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A recompensa já foi resgatada.`)
};

const ru_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уже запросили эту награду.`)
};

const th_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลนี้ได้ถูกแลกรับไปแล้ว`)
};

const tr_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödül zaten talep edildi.`)
};

const zh_cn_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此奖励已被领取`)
};

const zh_tw_dialog_claimd_content = /** @type {(inputs: Dialog_Claimd_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此獎勵已被領取`)
};

/**
* | output |
* | --- |
* | "The reward has already been claimed." |
*
* @param {Dialog_Claimd_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_claimd_content = /** @type {((inputs?: Dialog_Claimd_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Claimd_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_claimd_content(inputs)
	if (locale === "ar") return ar_dialog_claimd_content(inputs)
	if (locale === "de") return de_dialog_claimd_content(inputs)
	if (locale === "es") return es_dialog_claimd_content(inputs)
	if (locale === "fr") return fr_dialog_claimd_content(inputs)
	if (locale === "it") return it_dialog_claimd_content(inputs)
	if (locale === "ja") return ja_dialog_claimd_content(inputs)
	if (locale === "ko") return ko_dialog_claimd_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_claimd_content(inputs)
	if (locale === "ru") return ru_dialog_claimd_content(inputs)
	if (locale === "th") return th_dialog_claimd_content(inputs)
	if (locale === "tr") return tr_dialog_claimd_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_claimd_content(inputs)
	return zh_tw_dialog_claimd_content(inputs)
});